import { render, staticRenderFns } from "./Imgs.vue?vue&type=template&id=154ca1ba&scoped=true&"
import script from "./Imgs.vue?vue&type=script&lang=js&"
export * from "./Imgs.vue?vue&type=script&lang=js&"
import style0 from "./Imgs.vue?vue&type=style&index=0&id=154ca1ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ca1ba",
  null
  
)

export default component.exports